// The Farsi surface is NOT on this app any more.
//
// It was gazar.dev/fa for one day, 20 to 21 Aug 2026, and is now its own SSR
// app at fa.gazar.dev (apps/fa). `/fa` and `/fa/*` are 301'd there in server.js.
//
// This file used to carry FA_PATH, FA_URL and FA_WAITLIST_SOURCE. All three
// moved with the page: the waitlist source now lives in apps/fa/src/lib/api.ts,
// tagged identically so the Farsi list stays one continuous count across the
// move. What remains is the one thing this app still needs, which is knowing
// that a /fa request is on its way out so the RTL chrome is not applied to a
// redirect.
export const FA_PATH = "/fa";

export function isFaPath(pathname: string) {
  return pathname === FA_PATH || pathname.startsWith(`${FA_PATH}/`);
}
